import { verifyPayment } from './verify-payment';

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Polls a PENDING checkout a few times before the caller offers a new one:
 * the Recurrente webhook can lag behind a payment the user already made.
 * Resolves true once the checkout reads paid; a failed read counts as a try.
 */
export async function waitForPayment(
	checkoutId: string,
	{ attempts = 3, intervalMs = 2_000 } = {},
): Promise<boolean> {
	for (let attempt = 0; attempt < attempts; attempt++) {
		if (attempt > 0) {
			await delay(intervalMs);
		}
		try {
			const verification = await verifyPayment(checkoutId);
			if (verification.status === 'paid') {
				return true;
			}
			if (verification.status === 'failed') {
				return false;
			}
		} catch {
			// Try again until the attempts run out.
		}
	}
	return false;
}
